import axiosInstance from './axios-auth';
const META_DOB = 'signup_date_of_birth';
const META_PE = 'signup_parent_email';
const META_PG = 'signup_parent_guardian_name';
/**
 * Persists signup-time DOB / parent contact from Supabase user_metadata onto `students`,
 * then clears the temporary metadata keys (best-effort).
 */
export async function syncPendingStudentSignupComplianceFromAuthUser(user) {
    const m = user.user_metadata;
    if (!m || typeof m[META_DOB] !== 'string' || !m[META_DOB].trim()) {
        return;
    }
    const body = {
        date_of_birth: m[META_DOB].trim()
    };
    if (typeof m[META_PE] === 'string' && m[META_PE].trim()) {
        body.parent_email = m[META_PE].trim();
    }
    if (typeof m[META_PG] === 'string' && m[META_PG].trim()) {
        body.parent_guardian_name = m[META_PG].trim();
    }
    await axiosInstance.patch('/students/settings', body);
    /* Intentionally leave signup_* metadata keys; harmless and avoids updateUser merge edge cases. */
}
